import React, { Component } from 'react';
import { Layout } from './Layout';
import AppButton from './AppButton';
import GoogleMapReact from 'google-map-react';
import configService from "../services/ConfigService";
import { SpeechBubble } from './SpeechBubble'
import './trackmydelivery.scss';

const FliwayTruckIcon = ({ text }) => (
    <div style={{
      color: 'white', 
      backgroundImage: 'url(/images/truck.png)',
      width: '52px',
      height: '52px',
      display: 'inline-flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      transform: 'translate(-50%, -50%)'
    }}>
      {text}
    </div>
  );

export class TrackMyDelivery extends Component {
    static displayName = TrackMyDelivery.name;

    constructor(props) {
        super(props);
        const { match: { params } } = this.props;
        this.state = {
            center: {
                lat: -36.877249,
                lng: 174.749546
            },
            iconCenter: {
                lat: -36.877249,
                lng: 174.749546
            },
            loading: true,
            trackingAvailable: false,
            zoom: 15,
            maxZoom: 15,
            params: params || {jobid: null}
        };   
        this.updatePosition = this.updatePosition.bind(this);
        this.apiIsLoaded = this.apiIsLoaded.bind(this);
        this.positionUpdateJob = null;
    }
    async componentDidMount() {                
        await this.updatePosition();
        let config = await configService.getConfig();
        var defaultZoom = 1*(config.mapDefaultZoom || 15);
        var maxZoom = 1*(config.mapMaxZoom || 15);
        this.setState({loading: false, zoom: defaultZoom, maxZoom: maxZoom});
        //console.log("setting tracking frequency", (config.trackingFrequencySeconds || 10)*1000);
        this.positionUpdateJob = setInterval(() => {this.updatePosition();}, (config.trackingFrequencySeconds || 10)*1000);        
    }

    componentWillUnmount(){
        clearInterval(this.positionUpdateJob);
    }

    async updatePosition() {
        let positionData; 
       
        if(this.state.params.jobid === "testing") {
            positionData = {location: { loc: {}}};
            positionData.location.loc["@lat"] = -36.849709;
            positionData.location.loc["@lon"] = 174.755880;
        }
        else {
            let trackingData = (await (await window.fetch('api/offer/' + this.state.params.jobid)));

            if(trackingData.status == "409"){
                alert("Sorry you cannot currently track this. Tap to refresh");
                return this.props.history.push(`../../o/${this.state.params.jobid}`);
            }
            else if(!trackingData.ok){
                alert("Error: " + trackingData.statusText);
                return;
            }

            positionData = await trackingData.json();
            console.log("positionData", positionData);
            if(positionData.shipment.status && positionData.shipment.status !== "DriverNear"){
                return this.props.history.push(`../../o/${this.state.params.jobid}`);
            }
            else if(positionData.location.message && positionData.location.message !== "") {
                //console.log(`tracking unavilable because: ${positionData.location.message}`);
                this.setState({trackingAvailable: false});
                return;
            }
        }        
        let lat = positionData.location.loc['@lat'];
        let lng = positionData.location.loc['@lon'];
        this.setState({trackingAvailable: true, iconCenter: {lat: lat, lng: lng}});
        //console.log('updating maps', this.map, this.maps, lat, lng);
        if(this.map && this.maps){            
            const latLng = new this.maps.LatLng(lat, lng);
            //console.log('panning to', latLng);
            this.map.panTo(latLng);
        }
    }

    async apiIsLoaded(api) {
        //console.log('google maps api loaded!', api);        
        this.map = api.map;
        this.maps = api.maps;      
        const latLng = new this.maps.LatLng(this.state.iconCenter.lat, this.state.iconCenter.lng);
        this.map.panTo(latLng);  

        let closeButton = document.createElement('div');
        closeButton.title = 'Click to stop tracking';
        closeButton.innerHTML = '&times;';
        closeButton.className = 'closeX';
        let props = this.props; 
        let state = this.state;
        closeButton.onclick = function () {
            props.history.push('../../o/' + state.params.jobid);
        };
        this.map.controls[this.maps.ControlPosition.LEFT_TOP].push(closeButton);
    }

    render() {
        let view;        
        if(this.state.loading === true)
            view = <div>Loading...</div>;
        else if(this.state.trackingAvailable === false)
            view =  <Layout>                        
                        <div className="header">Tracking: UNAVAILABLE</div>
                        <SpeechBubble text="Tracking Unavailable – Don't worry your delivery is still on its way" />
                        <AppButton iconName="icon-button-tick" actionText="Return to details" 
                                 onClick={() => { this.props.history.push('../../o/' + this.state.params.jobid) }} footer="Tap to return to details"/>
                    </Layout>;
        else
            view = <React.Fragment>
                <GoogleMapReact
                    bootstrapURLKeys={{ client: 'gme-fujitsu' }}
                    center={this.state.center}
                    defaultZoom={this.state.zoom} 
                    options={{maxZoom: this.state.maxZoom}}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={this.apiIsLoaded}
                    layerTypes={['TrafficLayer']}>
                        <FliwayTruckIcon
                            lat={this.state.iconCenter.lat}
                            lng={this.state.iconCenter.lng}
                            text=""
                        />
                </GoogleMapReact></React.Fragment>;

        return (
            <div style={{ height: '100%', width: '100%' }}>
                {view}
            </div>
        );
    }
}
